'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasTypicalResponseTimeMessageFromCurrentSession = undefined;

var _isTypicalResponseTimeMessage = require('../../pubnub-message/operators/isTypicalResponseTimeMessage');

var _getMessageIsApproximatelyFromCurrentSession = require('../../pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _hasMessages = require('./hasMessages');

var _getMessages = require('./getMessages');

var hasTypicalResponseTimeMessageFromCurrentSession = exports.hasTypicalResponseTimeMessageFromCurrentSession = function hasTypicalResponseTimeMessageFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var lastTypicalResponseTimeMessage = messages.findLast(_isTypicalResponseTimeMessage.isTypicalResponseTimeMessage);

  return !!(lastTypicalResponseTimeMessage && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(lastTypicalResponseTimeMessage));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasTypicalResponseTimeMessageFromCurrentSession.js
// module id = 759
// module chunks = 2 3